// Canonical listing of every path defined in App.js, split into:
//   - SITE_PAGES: real destination page routes (the ones that render content)
//   - HARDCODED_REDIRECTS: <Navigate/> routes in App.js. These behave as
//     redirects but live in the code, not the database. The admin displays
//     them read-only for visibility. Modifying one requires a code change.
//
// Keep this file in sync with App.js. `isReservedPath` treats BOTH lists as
// occupied so a database-driven redirect source can never be shadowed by a
// hardcoded route.
export const SITE_PAGES = [
  "/",
  "/about",
  "/ebook",
  "/cage-system",
  "/the-mission",
  "/contact",
  "/free-book",
  "/thank-you",
  "/reviews",
  "/leave",
  "/privacy",
  "/terms",
  "/risk-disclosure",
  "/admin",
  "/admin/reviews",
];

export const HARDCODED_REDIRECTS = [
  { source: "/review", destination: "/leave", type: 302 },
  { source: "/book", destination: "/free-book?src=book", type: 302 },
  { source: "/spiral-protocol", destination: "/cage-system?utm_source=book&utm_medium=referral&utm_campaign=spiral-protocol", type: 302 },
  { source: "/state-filter", destination: "/cage-system?utm_source=book&utm_medium=referral&utm_campaign=state-filter", type: 302 },
  { source: "/size-lock", destination: "/cage-system?utm_source=book&utm_medium=referral&utm_campaign=size-lock", type: 302 },
  { source: "/consistency-ledger", destination: "/cage-system?utm_source=book&utm_medium=referral&utm_campaign=consistency-ledger", type: 302 },
  { source: "/notify", destination: "/cage-system", type: 302 },
  { source: "/track-record", destination: "/the-mission", type: 302 },
  { source: "/track-record-embed", destination: "/the-mission", type: 302 },
];

// Public pages (everything except /admin*) — drives the campaign-link builder
// dropdown so new pages added to SITE_PAGES appear automatically.
export const PUBLIC_PAGES = SITE_PAGES.filter((p) => !p.startsWith("/admin"));

export const isReservedPath = (path) => {
  if (!path) return false;
  const p = String(path).trim().toLowerCase();
  if (SITE_PAGES.some((s) => s.toLowerCase() === p)) return true;
  return HARDCODED_REDIRECTS.some((r) => r.source.toLowerCase() === p);
};
